import template from "es6-template-strings";
import { isNil } from "kanopi-components/utils/primitives";
import { jsonToCamelCase, jsonStringToCamelCase } from "kanopi-components/utils/json";
import { toCamelCase } from "kanopi-components/utils/string";

export function substituteRiskData(enquiry, riskProfile = {}) {
  const { questionSet } = enquiry || {};
  const riskData = riskProfile.riskData ? JSON.parse(riskProfile.riskData) : {};
  const context = riskData;
  const newRiskProfile = {
    ...riskProfile,
    riskData: jsonToCamelCase(riskData),
  };
  return [
    {
      ...enquiry,
      riskProfile: newRiskProfile,
      questionSet: substituteQuestionSet(questionSet, context),
    },
    newRiskProfile,
  ];
}

export function substituteProfileData(enquiry, profile = {}) {
  const { questionSet } = enquiry || {};
  const profileData = profile?.data ? JSON.parse(profile?.data) : {};
  const riskData = profile.riskData ? JSON.parse(profile.riskData) : {};
  const context = profileData;
  const newRiskProfile = {
    ...profile,
    data: jsonToCamelCase(profileData),
    riskData: jsonToCamelCase(riskData), // To work with existing risk profile
  };
  return [
    {
      ...enquiry,
      riskProfile: newRiskProfile,
      questionSet: substituteQuestionSet(questionSet, context),
    },
    newRiskProfile,
  ];
}

export function substituteQuestionSet(questionSet, context) {
  if (!questionSet) {
    return questionSet;
  }
  const questions = questionSet.questions || [];
  return {
    ...questionSet,
    title: conditionalTemplate(questionSet.title, context),
    description: conditionalTemplate(questionSet.description, context),
    questions: questions.map((q) => substituteQuestion(q, context)),
    rhetoricals: substituteRhetoricals(questionSet.rhetoricals, context),
    validators: jsonStringToCamelCase(questionSet.validators),
  };
}

function substituteQuestion(question, context) {
  return {
    ...question,
    help: conditionalTemplate(question.help, context),
    label: conditionalTemplate(question.label, context),
    title: conditionalTemplate(question.title, context),
    inputArgs: jsonStringToCamelCase(question.inputArgs),
    storagePath: toCamelCase(question.storagePath),
    validators: jsonStringToCamelCase(question.validators),
    inputForm: substituteQuestionSet(question?.inputForm),
    default: question.default ? JSON.parse(question.default) : undefined,
    rhetoricals: substituteRhetoricals(question.rhetoricals, context),
    metadata: jsonStringToCamelCase(question.metadata),
  };
}

function substituteRhetoricals(rhetoricals, context) {
  return (rhetoricals || []).map((rhetorical) => {
    const mapped = {
      ...rhetorical,
      args: jsonStringToCamelCase(rhetorical.args),
    };
    Object.entries(mapped.args)
      .filter(([, value]) => typeof value === "string")
      .forEach(([key, value]) => {
        mapped.args[key] = conditionalTemplate(value, context);
      });
    return mapped;
  });
}

function conditionalTemplate(string, context) {
  if (isNil(string)) {
    return string;
  }
  return template(string, context, { partial: true });
}

/**
 * Translate the history entries onto the riskProfile for convenience.
 */
export function buildHistory(riskProfile, history) {
  riskProfile.history = (history || []).map((entry) => entry.questionSet);
}
